import React, { useEffect, useState } from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import LanguageSelect from '../../../../global/language-select/LanguageSelect';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import { createLocaleSpecifier } from '../../services/utils';
import Alert from '@amzn/meridian/alert';

const ADD_SUBWORKFLOW_WIDTH = '800px';

const AddSubworkflowModal = ({ open, existingSubworkflows, onCancel, onAccept }) => {
  const [sourceLocale, setSourceLocale] = useState(null);
  const [targetLocale, setTargetLocale] = useState(null);
  const [sourceSubworkflow, setSourceSubworkflow] = useState('');
  const [validSubworkflow, setValidSubworkflow] = useState(false);
  const [validSubworkflowMessage, setValidSubworkflowMessage] = useState(null);

  useEffect(() => {
    setValidSubworkflowMessage(null);
    setValidSubworkflow(true);
    if (targetLocale === null || sourceLocale === null) {
      setValidSubworkflow(false);
    }

    if (existingSubworkflows) {
      for (const subworkflow of existingSubworkflows) {
        if (subworkflow.targetLocale === targetLocale && subworkflow.sourceLocale === sourceLocale) {
          setValidSubworkflow(false);
          setValidSubworkflowMessage('The selected source/target locale pair already exists.');
          return;
        }
      }
    }
  }, [targetLocale, sourceLocale, sourceSubworkflow, existingSubworkflows]);

  const _cancelClickedCallback = () => {
    _resetFormValues();
    onCancel();
  };

  const _acceptClickedCallback = () => {
    onAccept(sourceLocale, targetLocale, sourceSubworkflow);
    _resetFormValues();
  };

  const _resetFormValues = () => {
    setSourceLocale(null);
    setTargetLocale(null);
    setSourceSubworkflow('');
  };

  return (
    <Modal
      title="Add New Subworkflow"
      open={open}
      scrollContainer="modal"
      closeLabel="Close"
      width={ADD_SUBWORKFLOW_WIDTH}
    >
      <div className="minh-300">
        <Text type="h100">Source Locale:</Text>
        <LanguageSelect controlledLocale={sourceLocale} onChange={setSourceLocale} />
        <Text type="h100">Target Locale:</Text>
        <LanguageSelect controlledLocale={targetLocale} onChange={setTargetLocale} />
        <Text type="h100">Copy from:</Text>
        <Select
          value={sourceSubworkflow}
          onChange={setSourceSubworkflow}
          placeholder="Select subworkflow to copy from..."
        >
          <SelectOption key="" value="" label="Don't inherit configuration" />
          {existingSubworkflows?.map(subworkflow => {
            const localeSpecifier = createLocaleSpecifier(subworkflow);
            return <SelectOption key={localeSpecifier} value={localeSpecifier} label={localeSpecifier} />;
          })}
        </Select>
        {validSubworkflowMessage && <Alert type="warning">{validSubworkflowMessage}</Alert>}
      </div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="secondary" size="small" onClick={_cancelClickedCallback}>
            Cancel
          </Button>
          <Button type="primary" size="small" disabled={!validSubworkflow} onClick={_acceptClickedCallback}>
            Accept
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default AddSubworkflowModal;
